import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import {
  isUserLoggedIn, getUserData, getUserRole, getHomeRouteForLoggedInUser,
} from '@/auth/utils'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'login' } },
    {
      path: '/admin',
      meta: {
        needLogin: true,
      },
      beforeEnter: (to, from, next) => {
        store.dispatch('auth/checkToken')
        next()
      },
      component: () => import('@/layouts/full/LayoutFull.vue'),
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/views/journeyDay/Index.vue'),
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import('@/views/account/AccountPage.vue'),
        },
        {
          path: 'traceabilities',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'traceabilities',
          component: () => import('@/views/users/UpdateJourneyLog.vue'),
        },
        {
          path: 'users/operarios',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin'],
          },
          name: 'operarios',
          component: () => import('@/views/users/Empleados.vue'),
        },
        {
          path: 'users',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'users',
          component: () => import('@/views/users/List.vue'),
        },
        {
          path: 'users/access-log',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin_empresa'],
          },
          name: 'users',
          component: () => import('@/views/users/AccessLog.vue'),
        },
        {
          path: 'users/edit/:id',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'editUser',
          component: () => import('@/views/users/Edit.vue'),
        },
        {
          path: 'users/view/:id',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'viewUser',
          component: () => import('@/views/users/View.vue'),
        },
        {
          path: 'users/create',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'createUser',
          component: () => import('@/views/users/Create.vue'),
        },
        {
          path: 'departments',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'departments',
          component: () => import('@/views/departments/List.vue'),
        },
        {
          path: 'departments/edit/:id',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'editDepartment',
          component: () => import('@/views/departments/Edit.vue'),
        },
        {
          path: 'departments/create',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'createDepartment',
          component: () => import('@/views/departments/Create.vue'),
        },
        {
          path: 'partes',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin', 'operario'],
          },
          name: 'partes',
          component: () => import('@/views/partes/Listado.vue'),
        },
        {
          path: 'fichar',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin', 'operario'],
          },
          name: 'journeyDay',
          component: () => import('@/views/journeyDay/Index.vue'),
        },
        {
          path: 'calendario',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'calendario',
          component: () => import('@/views/calendario/Calendario.vue'),
        },
        {
          path: 'calendario/:id/festivos',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'calendario-festivos',
          component: () => import('@/views/calendario/HolidaysPage.vue'),
        },
        {
          path: 'documents',
          meta: {
            needLogin: true,
            roleAllow: ['operario'],
          },
          name: 'documents',
          component: () => import('@/views/documents/viewOperario.vue'),
        },
        {
          path: 'admin-documents',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'adminDocuments',
          component: () => import('@/views/documents/viewAdmin.vue'),
        },
        {
          path: 'categories-documents',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'categoriesDocuments',
          component: () => import('@/views/documents/ListCategory.vue'),
        },
        {
          path: 'categories-documents/create',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'createCategoriesDocuments',
          component: () => import('@/views/documents/CreateCategory.vue'),
        },
        {
          path: 'categories-documents/view/:id',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'viewCategoriesDocuments',
          component: () => import('@/views/documents/ListCategory.vue'),
        },
        {
          path: 'categories-documents/edit/:id',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'editCategoriesDocuments',
          component: () => import('@/views/documents/EditCategory.vue'),
        },
        {
          path: 'config',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'config',
          component: () => import('@/views/clients/Edit.vue'),
        },
        {
          path: 'vacations',
          meta: {
            needLogin: true,
            roleAllow: ['admin', 'operario'],
          },
          name: 'vacations',
          component: () => import('@/views/vacations/View.vue'),
        },
        {
          path: 'vacations/request',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'vacations-admin',
          component: () => import('@/views/vacations/VacationRequestsAdmin.vue'),
        },
        {
          path: 'vacations/calendar',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin', 'operario'],
          },
          name: 'vacations-calendar-admin',
          beforeEnter: (to, from, next) => {
            const role = getUserRole()
            if (role === 'operario' && localStorage.getItem('canModuleCalendarPrivacy') !== 'true') {
              return next({ name: 'error-401' })
            }
            next()
          },
          component: () => import('@/views/vacations/VacationCalendarAdmin.vue'),
        },
        {
          path: 'policy',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'policy',
          component: () => import('@/views/configuracion/Policy.vue'),
        },
        {
          path: 'policy/view',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin', 'operario'],
          },
          name: 'viewPolicy',
          component: () => import('@/views/configuracion/ViewPolicy.vue'),
        },
        {
          path: 'clients/create',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin'],
          },
          name: 'createClient',
          component: () => import('@/views/clients/Create.vue'),
        },
        {
          path: 'configuracion',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'configuracion',
          component: () => import('@/views/configuracion/Configuracion.vue'),
        },
        {
          path: 'notificaciones',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'notificaciones',
          component: () => import('@/views/notificaciones/Notificaciones.vue'),
        },
        {
          path: 'horarios',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'horarios',
          component: () => import('@/views/schedule/Schedule.vue'),
        },
        {
          path: 'modulo-gestion-vacaciones',
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
          name: 'modulo-gestion-vacaciones',
          component: () => import('@/views/vacations/VacationGestionModule.vue'),
        },
        {
          path: '/settings/app-version',
          name: 'AppVersionEdit',
          component: () => import('@/views/configuracion/AppVersion.vue'),
          meta: {
            needLogin: true,
            roleAllow: ['super_admin'],
          },
        },
        {
          path: 'convenios',
          name: 'convenios',
          component: () => import('@/views/configuracion/RequestTypes.vue'),
          meta: {
            needLogin: true,
            roleAllow: ['super_admin', 'admin'],
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/politica-privacidad',
      name: 'policypublic',
      component: () => import('@/views/PolicyPublic.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/reset-password/:token/:email',
      name: 'reset-password',
      component: () => import('@/views/users/ResetPassword.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/reset-password-sms/:username',
      name: 'reset-password-sms',
      component: () => import('@/views/users/ResetPasswordSms.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-401',
      name: 'error-401',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (to.meta.needLogin) {
    if (!isLoggedIn) { return next({ name: 'login' }) }
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn === true && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData))
  }
  if (to.meta.roleAllow) {
    const role = getUserRole()
    if (!to.meta.roleAllow.includes(role)) {
      next({ name: 'error-401' })
    }
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
